import Marquee from "react-fast-marquee";

const items = [
  "ODD HOUR LESSONS 8PM–3AM",
  "QUIETER ROADS · LESS STRESS",
  "NERVOUS DRIVERS WELCOME",
  "LIFE DOESN'T RUN 9 TO 5",
  "COOLUM TO CALOUNDRA",
  "PATIENT & SUPPORTIVE",
];

export default function MarqueeStrip() {
  return (
    <div className="bg-[#F5B301] text-[#0a0a0a] py-5 -rotate-1 scale-[1.02] my-10 select-none" data-testid="marquee-strip">
      <Marquee speed={40} gradient={false}>
        {items.map((text) => (
          <span key={text} className="font-cabinet font-black uppercase tracking-tight text-2xl md:text-4xl mx-8 flex items-center gap-16">
            {text}
            <span className="text-white">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
